module.exports = __webpack_public_path__ + "img/user1.f89a28f2.png";